const compatModules = {};import * as Mod1 from "./discourse/components/post-menu/toggle-translation-button";
compatModules["discourse/components/post-menu/toggle-translation-button"] = Mod1;

export * as discourse$components$post__menu$toggle__translation__button$$__module from "./discourse/components/post-menu/toggle-translation-button";
export {
default as discourse$components$post__menu$toggle__translation__button$$default
} from "./discourse/components/post-menu/toggle-translation-button";
import * as Mod2 from "./discourse/components/translated-post-indicator";
compatModules["discourse/components/translated-post-indicator"] = Mod2;

export * as discourse$components$translated__post__indicator$$__module from "./discourse/components/translated-post-indicator";
export {
default as discourse$components$translated__post__indicator$$default
} from "./discourse/components/translated-post-indicator";
import * as Mod3 from "./discourse/components/translated-post";
compatModules["discourse/components/translated-post"] = Mod3;

export * as discourse$components$translated__post$$__module from "./discourse/components/translated-post";
export {
default as discourse$components$translated__post$$default
} from "./discourse/components/translated-post";
import * as Mod4 from "./discourse/initializers/extend-for-translate-button";
compatModules["discourse/initializers/extend-for-translate-button"] = Mod4;

export * as discourse$initializers$extend__for__translate__button$$__module from "./discourse/initializers/extend-for-translate-button";
export {
default as discourse$initializers$extend__for__translate__button$$default
} from "./discourse/initializers/extend-for-translate-button";
import * as Mod5 from "./discourse/services/translator";
compatModules["discourse/services/translator"] = Mod5;

export * as discourse$services$translator$$__module from "./discourse/services/translator";
export {
default as discourse$services$translator$$default
} from "./discourse/services/translator";
export default compatModules;
